export default function AuthenticationError() {
  return (
    <div role="alert">
      <h1>Kunde inte slutföra inloggningen</h1>
      <p>Ladda om sidan för att försöka igen.</p>
      <button type="button" onClick={() => window.location.reload()}>
        Försök igen
      </button>
    </div>
  );
}
